import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d4fc19e")

_pushScopeId("data-v-3d4fc19e")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("TODOを編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" TODOを削除 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" TODOを編集 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "タイトル",
          name: "title",
          type: "text",
          placeholder: "タイトルを記入してください。",
          value: _ctx.title,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.title = $event))
        }, null, 8, ["value"])
      ])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_button, {
          class: "mr-4",
          color: "red-400",
          "hover-color": "red-500",
          outline: "",
          onClick: _ctx.deleteTodo
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validData,
          onClick: _ctx.updateTodo
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})